import { BaseModel } from "./BaseModel";

export class QueryResult extends BaseModel {
  schema = "/queryresult";

  constructor(params) {
    return super(params, "/queryresult");
  }
}
